import Vue from 'vue'
import moment from 'moment/src/moment'

Vue.prototype.$moment = moment;
